export const layerIcon = [
  "24 24",
  `
    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M12,2L2,7l10,5l10-5L12,2z
	 M2,17l10,5l10-5 M2,12l10,5l10-5"/>
      
        `,
];
